import React from 'react';
import moment from 'moment';
import IntervalRenderer from 'flow/components/custom-components/interval-renderer';
import { getPrettyDuration } from 'flow/utils/call-utils';
import useAppContext from 'flow/hooks/useAppContext';

interface MeetingLargeCallItemProps {
    memberInChat: boolean;
    numberOfMembers: number;
    chatName?: string;
    displayNames?: string;
    meetingCallStartTime?: Date;
}

const MeetingLargeCallItem: React.FC<MeetingLargeCallItemProps> = ({
    memberInChat,
    numberOfMembers,
    chatName,
    displayNames,
    meetingCallStartTime,
}) => {
    const { i18next } = useAppContext();

    return (
        <div
            className="mx-3 my-1.5 mb-3 flex flex-col items-center justify-center rounded bg-gray-700 text-white"
            data-test-id={'meeting-large-call-item'}
        >
            <div className="mt-5 flex text-sm font-semibold">
                <IntervalRenderer interval={1000}>
                    {() =>
                        getPrettyDuration(
                            moment.duration(
                                moment().diff(moment(meetingCallStartTime)),
                            ),
                        )
                    }
                </IntervalRenderer>
            </div>

            <div className="m-3 flex h-21 w-21 items-center justify-center rounded-xl bg-purple-500 text-lg">
                {numberOfMembers}
            </div>

            <div className="mt-2.5 mb-6 flex flex-col items-center justify-center">
                <div className="text-base font-normal">
                    {memberInChat && chatName
                        ? chatName
                        : i18next.t('videoconference.meeting')}
                </div>
                <div className="text-sm text-gray-400">{displayNames}</div>
            </div>
        </div>
    );
};

export default MeetingLargeCallItem;
